/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const clinicSettingsLastSyncedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicSettingsLocationsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicSettingsLocationsItemPfHoursOneItemEndRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$|^24:00$')
export const clinicSettingsLocationsItemPfHoursOneItemStartRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$|^24:00$')
export const clinicSettingsLocationsItemPfHoursOneItemWeekdayMin = 0
export const clinicSettingsLocationsItemPfHoursOneItemWeekdayMax = 6

export const clinicSettingsPfMessagesContactsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicSettingsProfileHolidaysItemDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const clinicSettingsProfileHolidaysItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicSettingsProfileHolidaysItemLocationIdsOneItemRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicSettingsProfileHoursItemEndRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$|^24:00$')
export const clinicSettingsProfileHoursItemStartRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$|^24:00$')
export const clinicSettingsProfileHoursItemWeekdayMin = 0
export const clinicSettingsProfileHoursItemWeekdayMax = 6

export const clinicSettingsProvidersItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicSettingsRulesDefaultVisitTypeIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicSettingsUpdatedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const clinicSettingsUpdatedByOneUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicSettingsVersionMax = 9007199254740991

export const clinicSettingsVisitTypesItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const clinicSettingsVisitTypesItemPfDurationMinutesOneMin = -9007199254740991
export const clinicSettingsVisitTypesItemPfDurationMinutesOneMax = 9007199254740991

export const clinicSettingsVisitTypesItemProviderIdsOneItemRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)

export const ClinicSettings = zod.object({
  coverageOptions: zod.array(
    zod.object({
      code: zod.string(),
      name: zod.string(),
    }),
  ),
  lastSyncedAt: zod.union([zod.iso.datetime({ offset: true }).regex(clinicSettingsLastSyncedAtOneRegExp), zod.null()]),
  locations: zod.array(
    zod.object({
      address: zod.string(),
      id: zod.uuid().regex(clinicSettingsLocationsItemIdRegExp),
      isNew: zod.boolean(),
      name: zod.string(),
      pfHours: zod.union([
        zod.array(
          zod.object({
            end: zod.string().regex(clinicSettingsLocationsItemPfHoursOneItemEndRegExp),
            open: zod.boolean(),
            start: zod.string().regex(clinicSettingsLocationsItemPfHoursOneItemStartRegExp),
            weekday: zod
              .int()
              .min(clinicSettingsLocationsItemPfHoursOneItemWeekdayMin)
              .max(clinicSettingsLocationsItemPfHoursOneItemWeekdayMax),
          }),
        ),
        zod.null(),
      ]),
      pfId: zod.string(),
      removedInPf: zod.boolean(),
      visible: zod.boolean(),
    }),
  ),
  pfMessages: zod.object({
    body: zod.string().nullable(),
    conflictLine: zod.string().nullable(),
    contacts: zod.array(
      zod.object({
        id: zod.uuid().regex(clinicSettingsPfMessagesContactsItemIdRegExp),
        isNew: zod.boolean(),
        isRecipient: zod.boolean(),
        name: zod.string(),
        removedInPf: zod.boolean(),
      }),
    ),
    defaults: zod.object({
      body: zod.string(),
      conflictLine: zod.string(),
      subject: zod.string(),
    }),
    enabled: zod.boolean(),
    subject: zod.string().nullable(),
  }),
  profile: zod.object({
    contact: zod.object({
      address: zod.string(),
      email: zod.string(),
      phone: zod.string(),
    }),
    holidays: zod.array(
      zod.object({
        date: zod.string().regex(clinicSettingsProfileHolidaysItemDateRegExp),
        id: zod.uuid().regex(clinicSettingsProfileHolidaysItemIdRegExp),
        locationIds: zod.union([
          zod.array(zod.uuid().regex(clinicSettingsProfileHolidaysItemLocationIdsOneItemRegExp)),
          zod.null(),
        ]),
        name: zod.string(),
      }),
    ),
    hours: zod.array(
      zod.object({
        end: zod.string().regex(clinicSettingsProfileHoursItemEndRegExp),
        open: zod.boolean(),
        start: zod.string().regex(clinicSettingsProfileHoursItemStartRegExp),
        weekday: zod.int().min(clinicSettingsProfileHoursItemWeekdayMin).max(clinicSettingsProfileHoursItemWeekdayMax),
      }),
    ),
  }),
  providers: zod.array(
    zod.object({
      bio: zod.string(),
      color: zod.string(),
      credentials: zod.string(),
      id: zod.uuid().regex(clinicSettingsProvidersItemIdRegExp),
      isNew: zod.boolean(),
      name: zod.string(),
      pfId: zod.string(),
      removedInPf: zod.boolean(),
      specialty: zod.string(),
      visible: zod.boolean(),
    }),
  ),
  reasonMaxLength: zod.literal(500),
  rules: zod.object({
    bookingWindowDays: zod.union([zod.literal(14), zod.literal(30), zod.literal(45), zod.literal(60), zod.literal(90)]),
    coverageCode: zod.string(),
    defaultDurationMinutes: zod.union([
      zod.literal(15),
      zod.literal(20),
      zod.literal(30),
      zod.literal(45),
      zod.literal(60),
    ]),
    defaultVisitTypeId: zod.union([zod.uuid().regex(clinicSettingsRulesDefaultVisitTypeIdOneRegExp), zod.null()]),
    minNoticeHours: zod.union([
      zod.literal(0),
      zod.literal(1),
      zod.literal(2),
      zod.literal(4),
      zod.literal(24),
      zod.literal(48),
    ]),
    visitReasons: zod.array(zod.string()),
  }),
  testingIgnorePfHours: zod.boolean(),
  updatedAt: zod.iso.datetime({ offset: true }).regex(clinicSettingsUpdatedAtRegExp),
  updatedBy: zod.union([
    zod.object({
      name: zod.string(),
      userId: zod.uuid().regex(clinicSettingsUpdatedByOneUserIdRegExp),
      viaImpersonation: zod.boolean(),
    }),
    zod.null(),
  ]),
  version: zod.int().min(1).max(clinicSettingsVersionMax),
  visitTypes: zod.array(
    zod.object({
      durationOverrideMinutes: zod.union([
        zod.union([
          zod.literal(15),
          zod.literal(20),
          zod.literal(30),
          zod.literal(45),
          zod.literal(60),
          zod.literal(90),
        ]),
        zod.null(),
      ]),
      enabled: zod.boolean(),
      id: zod.uuid().regex(clinicSettingsVisitTypesItemIdRegExp),
      isNew: zod.boolean(),
      name: zod.string(),
      pfDurationMinutes: zod.union([
        zod
          .int()
          .min(clinicSettingsVisitTypesItemPfDurationMinutesOneMin)
          .max(clinicSettingsVisitTypesItemPfDurationMinutesOneMax),
        zod.null(),
      ]),
      pfId: zod.string(),
      providerIds: zod.union([
        zod.array(zod.uuid().regex(clinicSettingsVisitTypesItemProviderIdsOneItemRegExp)),
        zod.null(),
      ]),
      removedInPf: zod.boolean(),
      telehealth: zod.boolean(),
    }),
  ),
})

export type ClinicSettings = zod.input<typeof ClinicSettings>
export type ClinicSettingsOutput = zod.output<typeof ClinicSettings>
